import { useContext } from 'react'
import { GlobalSearchContext } from '../context/GlobalSearchContext'
import useGoBackState from 'shared/hooks/useGoBackState'
import { GlobalSearch, IconEconomy } from '@bbl-digital/snorre-v2'

export const AccountSearchHits = () => {
  const { loading, accountHits } = useContext(GlobalSearchContext)
  const { push } = useGoBackState()

  const hasAccountHits = accountHits?.hits?.length

  const goToAccount = (accountNo: string) => {
    push(`/okonomi/saldobalanse/${accountNo}/transaksjoner`)
  }

  if (loading || !hasAccountHits) return null

  const Hits = () => {
    return accountHits.hits?.map((item) => (
      <GlobalSearch.Item
        key={item.accountNo}
        label={item.accountName}
        subtitle={`Kontonummer: ${item.accountNo}`}
        icon={<IconEconomy backgrounded colorVariant="primary" />}
        options={{
          renderHighlightsAsHtml: true,
        }}
        onClick={() => goToAccount(item.accountNo)}
      />
    ))
  }

  return (
    <GlobalSearch.Group label="Regnskapskonto" title="Regnskapskonto">
      <Hits />
    </GlobalSearch.Group>
  )
}
